The partial position profile to suggest a job category for.

This should include the same field values that will eventually be used to create or post the `PositionProfile`.
